module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-index-thumbnails-1920x1080-7bc298547c03d43a493829d91effd496.jpg";